/* Domain dependencies */
import { appointmentModel } from '@/domain/appointment/appointment.model';

/* Application dependencies */
import { listAppointmentsExecute } from '@/application/appointment/list-appointments.use-case';

/* Infrastructure dependencies */
import { apiGetAppointmentList } from '@/infrastructure/apis/attention-queues';
import { selectMessage } from '@/infrastructure/utils/modals';
import { API_GET_APPOINTMENTS_MESSAGES } from '@/infrastructure/apis/messages/attention-queues.message';

const namespaced = true;

const state = () => ({
  ...appointmentModel,
});

const getters = {
  appointmentList: (state) => state.appointmentList,
};

const mutations = {
  SET_APPOINTMENT(state, data) {
    state.appointmentList = data;
  },
};

const actions = {
  async fetchAppointmentsAction({ commit, dispatch }, attentionType) {
    try {
      commit('SET_APPOINTMENT', []);
      const { listAppointments } = await listAppointmentsExecute(
        attentionType,
        apiGetAppointmentList
      );
      commit('SET_APPOINTMENT', listAppointments);
    } catch (error) {
      const message = selectMessage({
        responseCode: error.errorCode,
        messageObject: API_GET_APPOINTMENTS_MESSAGES,
        newMessage: error.message,
      });
      dispatch('alerts/addAlert', message, { root: true });
    }
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
